/* eslint-disable */
import React, { FC, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { RootState } from '../../redux/rootReducer';
import withLocalization from '../hoc/withLocalization';
import chekMarkIntlLogo from '../../features/siteTheme/Brands/tmvcs/logo/checkMarkIntlLogo.svg';
import ParticipationDetails from '../ParticipationDetails/ParticipationDetails';
import BookingTravelModal from './BookingTravelModal';
import { getForLabelValue } from '../../util/CommonLogic';
import { OfferSubContainer } from './OfferDetailsStyled';
import ParseHtml from '../common/ParseHtml';
import isAsia from '../../util/isAsia';
import {
  replacePlaceholder,
  removeDecimalPart,
  capitalizeFirstLetter,
  calculateMonthsUntilUpcomingDate,
} from '../../util/CommonLogic';
import { formatPackageDate } from '../../util/date';
import './PackageOfferDetails.scss';
import { loadOfferDetails } from '../../features/offerSearch/offerSearchSlice';

interface SearchPanelProps {
  localize?: any;
  localizeImages?: any;
  offersData?: any;
  leadDetails?: any;
  handlePayClick: () => void;
}
const PackageOfferDetails: FC<SearchPanelProps> = (props: SearchPanelProps) => {
  const { localize, offersData, leadDetails, handlePayClick } = props;
  const dispatch = useDispatch();
  const pinLeadDetails: any = useSelector((state: RootState) => state.pinOptFlowDetails.pinOptFlowLeadInfo);
  const prospectDetails: any = useSelector((state: RootState) => state.offerDetails.prospect);
  const pinInfoDetails: any = useSelector((state: RootState) => state.pinOptFlowDetails.pinDetails);
  const navigate = useNavigate();
  const [participationModalOpen, setParticipationModalOpen] = useState(false);
  const [bookModalOpen, setBookModalOpen] = useState(false);
  const spOffer = localize('preview-sales-engine.static-content.copy.pbeo.offer-eyebrow') || '';
  const tourType = offersData?.tourTp || '';
  const isTr = tourType && tourType.toUpperCase() === 'TR' ? true : false;
  const firstName = offersData?.firstName || '';
  const capFirstName = capitalizeFirstLetter(firstName);
  const lastName = offersData?.lastName || '';
  const capLastName = capitalizeFirstLetter(lastName);
  let ackDec: any;
  let refineSpOffer: any;
  if (isAsia) {
    const pkgTitle = localize(`preview-sales-engine.static-content.copy.pbeo.intl.asia-offer-for-you-eyebrow-text`);
    refineSpOffer = replacePlaceholder(pkgTitle, '{0}', capFirstName);
    ackDec = isTr
      ? localize(`preview-sales-engine.static-content.copy.pbeo.intl.asia-presentation-required`)
      : localize(`preview-sales-engine.static-content.copy.pbeo.intl.intl-overview-disclaimer-tnr`);
  } else {
    const pkgTitle = localize(`preview-sales-engine.static-content.copy.pbeo.intl.me-offer-for-you-eyebrow-text`);
    refineSpOffer = replacePlaceholder(pkgTitle, '{0}', capLastName);
    ackDec = isTr
      ? localize(`preview-sales-engine.static-content.copy.pbeo.intl.me-presentation-required`)
      : localize(`preview-sales-engine.static-content.copy.pbeo.intl.me-overview-disclaimer-tnr`);
  }
  const holiDaySurCharge = offersData?.holidaySurcharge || '';

  //const refineSpOffer = replacePlaceholder(spOffer, '{name}', capFirstName);
  const refOfferTitle = refineSpOffer?.split(',');
  const roomType = (offersData?.roomTypes && offersData?.roomTypes[0]) || {};
  const lowSeasonCost = roomType?.startingCost || '';
  const HighSeasonCost = roomType?.highSeasonCost || '';
  const chkFor = getForLabelValue(HighSeasonCost, lowSeasonCost, holiDaySurCharge);
  const isForLabel = chkFor
    ? localize('preview-sales-engine.static-content.copy.pbeo.offer-details-for-label')
    : localize('preview-sales-engine.static-content.copy.pbeo.offer-details-from-label');

  const roomDesc = roomType?.roomTypeDescription || '';
  const pkgDays = roomType?.numberOfDays || '';
  const pkgNight = roomType?.numberOfNights || '';
  const stayText = localize('preview-sales-engine.static-content.copy.pbeo.package-overview-days-nights-label');
  const updatedDays = replacePlaceholder(stayText, '{days}', pkgDays);
  const updatedStay = replacePlaceholder(updatedDays, '{nights}', pkgNight);
  const propName = offersData?.property?.name || '';
  const atText = localize('preview-sales-engine.static-content.copy.pbeo.offer-details-at-label');
  const stayAt = `${updatedStay} ${atText} ${propName}`;
  const maxGuest = roomType?.sleepCapacity || '';
  const maxGuestText = localize('preview-sales-engine.static-content.copy.pbeo.package-overview-max-guests-label');
  const updatedGuest = replacePlaceholder(maxGuestText, '{guests}', maxGuest);
  const state = roomType?.property?.stateProvince || '';
  const country = roomType?.property?.country || '';
  const pbeLocation = roomType?.property?.pbeLocation || '';
  const hotelFlag = roomType?.property?.isHotel || '';
  const isHotel = hotelFlag?.toUpperCase() === 'Y' ? true : false;
  const address =
    state && state.trim().toLowerCase() !== country.trim().toLowerCase() ? `${state}, ${country}` : country;
  const resortAddr = pbeLocation ? pbeLocation : address;
  const finalAddress = isHotel ? address : resortAddr;
  const minCost = offersData?.minimumStartingCost || '';
  const minCostArr = minCost.split('$');
  const MinVal = minCostArr && minCostArr[1] ? removeDecimalPart(minCostArr[1]) : '';
  const gift = (offersData?.premiums && offersData?.premiums[0]) || '';
  const bookToDate = offersData?.bookToDate || '';
  const difDates = calculateMonthsUntilUpcomingDate(offersData?.finalDate);
  const totalMonths: any = difDates || '';
  // const travelDate = formatPackageDate(bookToDate);
  const expirationTerm = formatPackageDate(offersData?.expirationTerm) || '';
  const travelText = localize('preview-sales-engine.static-content.copy.pbeo.package-overview-travel-dates-label');
  //const updatedTrText = replacePlaceholder(travelText, '{months}', expirationTerm);
  const updatedTrText = replacePlaceholder(travelText, '{months}', totalMonths);
  const payBtnText = localize('preview-sales-engine.static-content.copy.pbeo.intl.intl-claim-offer-cta-label');
  const depositeAmt = roomType?.depositAmount || '';
  const updateDeposite = removeDecimalPart(depositeAmt);
  const updatedPayBtnText = replacePlaceholder(payBtnText, '{0}', updateDeposite);
  const symbol = localize('preview-sales-engine.static-content.copy.pbeo.intl.usd-label');
  const retVal = offersData?.retailValue || '';
  const retailFlag = retVal ? true : false;
  const claimToday = localize('preview-sales-engine.static-content.copy.pbeo.intl.offer-full-payment-cta-label');
  const retailPrice = roomType?.highSeasonRetailPrice || '';
  const updatedRetPrice = retailPrice || retVal;
  const splitRetVal = updatedRetPrice?.split('$') || '';
  const refineRetPrice = removeDecimalPart(splitRetVal[1]) || '';
  const showDepositAmt = `${symbol}${refineRetPrice}`;

  const formatedRoomDesc = capitalizeFirstLetter(roomDesc);

  const depositeAmtArr = updateDeposite?.split('$') || '';
  const subAmt = parseInt(MinVal) - parseInt(depositeAmtArr[1]);
  const chkAmt = subAmt < 1;

  const removePayBtnText = replacePlaceholder(updatedPayBtnText, '$', symbol);
  const refineBtnText = chkAmt ? claimToday : removePayBtnText;

  const openParticipationModal = () => {
    setParticipationModalOpen(true);
  };
  const closeModal = () => {
    setParticipationModalOpen(false);
  };

  //AM-8100
  useEffect(() => {
    if (prospectDetails && prospectDetails?.firstName) {
      const getUrlSearchParam = sessionStorage.getItem('pinOptUrlSearchParam') || '';
      navigate('/validate' + getUrlSearchParam);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [prospectDetails]);
  // const handlePayBooking = () => {
  //   // bubble event to parent
  //   if (handlePayClick) {
  //     handlePayClick();
  //   }
  //   const getUrlSearchParam = sessionStorage.getItem('pinOptUrlSearchParam') || '';
  //   navigate('/payment' + getUrlSearchParam);
  //   // navigate('/thank-you' + getUrlSearchParam);
  // };

  const handlePayBooking = () => {
    dispatch(loadOfferDetails(pinInfoDetails?.pin, pinInfoDetails?.lastName, 'n', true));
  }
  const clickBookTravel = () => {
    // setBookModalOpen(true);
  };

  const closeBookModal = () => {
    setBookModalOpen(false);
  };
  return (
    <>
      {bookModalOpen && <BookingTravelModal closeModal={closeBookModal} />}
      {participationModalOpen && <ParticipationDetails closeModal={closeModal} />}
      <div className="PackageInfoCard">
        <OfferSubContainer retalvelue={retailFlag}>
          <div className="PackageInfo-card-content">
            <div className="pkgInfo-card-Header">
              <span className="pkgInfo-card-specialOfferText">{`${refOfferTitle[0]},`}</span>
              <span className="pkgInfo-card-maximilianoText">{refOfferTitle[1]}</span>
            </div>
            <div className="pkfInfoCard-TopSection">
              <div className="pkfInfoCard-TopSection-title">
                <span className="pkgCardTitle-cnt-Text">{updatedStay}</span>

                <span className="pkgCardTitle-name-Text">{finalAddress}</span>
              </div>
              <div className="pkfInfoCard-TopSection-price">
                <span className="pkgCardPrice-from-Text">{isForLabel}</span>
                <div>
                  <span className="pkgCard-symbol-Text">
                    {localize('preview-sales-engine.static-content.copy.pbeo.intl.usd-label')}
                  </span>

                  <span className="pkgCard-actualVal-Text">
                    {MinVal}
                    <span className="small-asterisk">*</span>
                  </span>
                </div>
                {refineRetPrice && (
                  <div className="pkgCardPrice-Value-Container">
                    <span className="pkgCardPrice-value strike-red">{showDepositAmt}</span>

                    <span className="pkgCardPrice-value">
                      {localize('preview-sales-engine.static-content.copy.pbeo.intl.intl-retail-value-label')}
                    </span>
                  </div>
                )}
              </div>
            </div>
            <div className="pkgCard-list-container">
              <span className="pkgCard-list-head">
                {localize('preview-sales-engine.static-content.copy.pbeo.offer-inclusion-label')}
              </span>
              <div className="pkgCard-list-detail-container">
                <div className="pkgCard-listRow ">
                  <img src={chekMarkIntlLogo} alt={'check'} className="pkgCard-list-cl-check" />
                  <button className="pkgCard-list-cl-detail">{updatedStay}</button>
                </div>
                <div className="pkgCard-listRow ">
                  <img src={chekMarkIntlLogo} alt={'check'} className="pkgCard-list-cl-check" />
                  <button className="pkgCard-list-cl-detail">{propName}</button>
                </div>
                <div className="pkgCard-listRow ">
                  <img src={chekMarkIntlLogo} alt={'check'} className="pkgCard-list-cl-check" />
                  <button className="pkgCard-list-cl-detail">{formatedRoomDesc}</button>
                </div>
                <div className="pkgCard-listRow ">
                  <img src={chekMarkIntlLogo} alt={'check'} className="pkgCard-list-cl-check" />
                  <button className="pkgCard-list-cl-detail">{updatedGuest}</button>
                </div>
                <div className="pkgCard-listRow ">
                  <img src={chekMarkIntlLogo} alt={'check'} className="pkgCard-list-cl-check" />
                  <button className="pkgCard-list-cl-detail" onClick={() => clickBookTravel()}>
                    {updatedTrText}
                  </button>
                </div>
                {gift && (
                  <div className="pkgCard-listRow-bonus">
                    <div>
                      {/*<span className="bonus-cl-bonus-text">
                        {localize('preview-sales-engine.static-content.copy.pbeo.package-summary-gift-label')}
                      </span>*/}
                      <span className="bonus-cl-Gift-text">{gift}</span>
                    </div>
                  </div>
                )}
              </div>
            </div>
            <div className="pkgInfoCard-pay-container">
              <button className="pkgCard-pay-btn" onClick={() => handlePayBooking()}>
                {refineBtnText}
              </button>
              <span className="legalStatement-note">
                <ParseHtml htmlInput={ackDec}></ParseHtml>
              </span>
              <button className="pkgCard-detail-Paticipate" onClick={() => openParticipationModal()}>
                {localize('preview-sales-engine.static-content.copy.pbeo.intl.intl-terms-and-conditions-label')}
              </button>
            </div>
          </div>
        </OfferSubContainer>
      </div>
    </>
  );
};
export default withLocalization(PackageOfferDetails);
